










































































import Vue from 'vue';
import moment from 'moment';
import { Component, Prop } from 'vue-property-decorator';
import { POSProductForContact } from '@pos/interfaces/pos-v2';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faCalendarCheck, faUserCheck, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import { CenterSetting } from '@core/interfaces/center-setting';

library.add(faCalendarCheck, faUserPlus, faUserCheck);

@Component({
  name: 'bpc-pos-contact-details-column',
  components: {},
})
export default class PosContactDetailsColumn extends Vue {
  // PROPS
  @Prop({ type: String, required: true }) readonly name: string;
  @Prop({ type: Boolean, default: false }) readonly cancelable: boolean;
  @Prop({ type: Array, required: true }) readonly products: POSProductForContact[];
  @Prop({ type: Boolean, default: true }) readonly readOnlyTicket: boolean;
  @Prop({ type: Boolean, default: false }) readonly changingQuantity: boolean;

  // DATA

  // COMPUTED

  get centerSetting(): CenterSetting {
    return this.$store.getters['centerSettings/centerSettings'];
  }

  // LIFECYCLE HOOKS

  // METHODS

  isCancelable(): boolean {
    return (
      this.cancelable && (!!this.centerSetting.pos_refunds_allowed || this.$authService.isAdmin())
    );
  }

  cancelProduct(product: POSProductForContact) {
    this.$emit('on-cancel-product', { name: this.name, product: product });
  }

  changeQuantity(product: POSProductForContact, increment: number) {
    this.$emit('on-increment-credits', {
      name: this.name,
      product: product,
      increment: increment,
    });
  }

  formatDate(value: string) {
    return this.$bpcHelper.formatDate(value);
  }

  formatDateTime(value: string) {
    return this.$bpcHelper.formatDateTime(value);
  }

  formatShortDateTimeRange(startDateTime: string, endDateTime: string) {
    if (!startDateTime) {
      return '';
    }
    const locale = this.lang === 'be' ? 'fr' : this.lang;
    const start = moment(String(startDateTime))
      .locale(locale)
      .format('ddd DD/MM HH:mm');
    if (start) {
      let end = '';
      if (endDateTime) {
        end = moment(String(endDateTime)).format('HH:mm');
      }
      if (end) {
        return start + ' - ' + end;
      } else {
        return start;
      }
    } else {
      return '';
    }
  }

  get lang(): string {
    return this.$store.getters['auth/userLang'];
  }

  // WATCHERS
}
